import React, { useState, useEffect, useContext } from "react";
import { Form, Button } from "react-bootstrap";
import StarRatings from "react-star-ratings";
import { toast } from "react-toastify";
import businessService from "../../services/businessService";
import reviewService from "../../services/reviewService";
import socialService from "../../services/socialService";

export default function ReviewCreatorForm(props) {
  const social = props.social;
  const reviewerID = props.businessID;
  const [stars, setStars] = useState(0);
  const [body, setBody] = useState("");
  const [title, setTitle] = useState("");
  //   const [socials, setSocials] = useState([]);
  //   const [reviewerID, setReviewerID] = useState(null);

  useEffect(() => {
    // console.log(props);
    // fetchUserSocials();
  }, [props.jwt]);


  const submitReview = (e) => {
    e.preventDefault();
    if (!body || !title) {
      toast.error("Add body and title");
      return;
    }
    const reviewData = {
      // reviewer_type: props.user.type,
      reviewee_type: "social",
      reviewer_id: reviewerID,
      reviewee_id: social.id,
    };
    reviewService
      .create(reviewData, title, body, stars, props.jwt)
      .then((response) => {
        // console.log("review create: ", response.data);
        toast.success("Review added!")
        props.onReviewSucceeded();
      })
      .catch((err) => {
        toast.error(err.response.data.msg || "Error occurred")
      });
  };

  if (
    !props.user ||
    !props.user.Business ||
    props.user.Business.status != "claimed"
  ) {
    return (
      <div className="col-6">
        <h3>Sorry, your business is not verified</h3>
        <p>
          To write a review for {social.handle} make sure you add a business and
          follow the instructions so we know you own it
        </p>
      </div>
    );
  }

  return (
    <div className="col-6">
      <h3>Write a review about {social.handle}</h3>
      <Form>
        <Form.Group controlId="formRating">
          <Form.Label>Rating</Form.Label>
          <br></br>
          <StarRatings
            rating={stars}
            starRatedColor="gold"
            starDimension="40px"
            starSpacing="1px"
            starHoverColor="gold"
            changeRating={(newRating) => setStars(newRating)}
            numberOfStars={5}
            name="rating"
          />
        </Form.Group>

        <Form.Group controlId="formTitle">
          <Form.Label>Review title</Form.Label>
          <Form.Control
            onChange={(e) => setTitle(e.target.value)}
            type="text"
            placeholder="Enter title"
          />
        </Form.Group>

        <Form.Group controlId="formBody">
          <Form.Label>Review body</Form.Label>
          <Form.Control
            onChange={(e) => setBody(e.target.value)}
            as="textarea"
            rows={3}
            placeholder="Heres my review ..."
          />
        </Form.Group>
        {/* <Form.Group controlId="formBody">
          <Form.Label>I worked with them on:</Form.Label>
          {socials.map((item) => {
            return (
              <Form.Check
                onClick={() => {
                  setReviewerID(item.id);
                }}
                name="handleOptions"
                type="radio"
                label={`${item.platform} : @${item.handle}`}
                id={item.id}
              />
            );
          })}
        </Form.Group> */}
        <Button variant="primary" type="submit" onClick={submitReview}>
          Submit
        </Button>
      </Form>
    </div>
  );
}
